import { useMutation } from '@tanstack/react-query';
import { acceptUserTerms } from 'api/accept-user-terms';

export const useAcceptUserTerms = () =>
  useMutation({
    mutationFn: acceptUserTerms,
  });
